export var Name = 'product-listing-user-event';
export var ProductListingUserEvent = Name;
export var UserEventType;
(function (UserEventType) {
  UserEventType["LoadMore"] = "LOAD_MORE_PRODUCTS";
  UserEventType["ProductsFilter"] = "PRODUCTS_FILTER";
})(UserEventType || (UserEventType = {}));